import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 84CE3480-8C26-4B78-9524-CB8E6AA23F1D
 * name store-alert
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-alert.svg
 * tags
 * - Places 
 * - Shopping 
 * - Alert / Error 
 */
export const StoreAlertIcon = createSvgIcon(<><path d="M2 7L1 12V14H2V20H12V14H16V20H18V14H19V12L18 7H2M10 18H4V14H10V18M18 6H2V4H18V6M23 7V13H21V7H23M21 15H23V17H21V15Z" /></>, 'StoreAlertIcon');
export default StoreAlertIcon